<template>
    <template-card-v2
        :oneLog="oneLog"
        :linkedtype="linkedtype"
        :linkedid="linkedid"
        :hasHistory="false"
    >
        <template #label>{{ oneLog.title }}</template>

        <template #content>
            <div class="pre-line" v-html="oneLog.content" />
        </template>
    </template-card-v2>
</template>

<script>
import TemplateCardV2 from './TemplateCardV2.vue';
import TimelineCardMixin from './TimelineCardMixin.js';

export default {
    components: {
        TemplateCardV2,
    },
    mixins: [TimelineCardMixin],
};
</script>
<style lang="scss" scoped>
.pre-line {
    white-space: pre-line;
}
</style>
